<template>
    <div class="help-center">
		<Loading v-if="!loading"/>
		<div v-if="loading">
			<ul class="help-list" v-for="(item,index) in qList" :key="index">
				<router-link :to="{name:'helpdetail',query:{id:item&&item.id}}"><li><span class="title">{{item&&item.title}}</span><van-icon name="arrow" /></li></router-link>
			</ul>
		</div>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
export default {
	name:'HelpCenter',
	data(){
		return{
			qList:[],         //问题列表
			loading:false      //问题数据加载状态
		}
	},
	created(){
		Axios.get('/common/help').then(
			response=>{
				if(response.data.code==200&&response.data.status=="success"){
					this.qList=response.data.data
					this.loading=true
				}
			}
		).catch(
			error=>{
				console.log(error)
			}
		)
	},
	components:{
		Loading
	}
}
</script>

<style lang="scss" scoped>
    .help-center{
        padding-top:88px;
        background:#f8f6f7;
        .help-list{
            li{
                padding:36px 44px;
                background:#fff;
                margin-bottom:10px;
                font-weight:bold;
                font-size:26px;
                color:#222;
                overflow:hidden;
                .title{
                    float:left;
                }
                .van-icon-arrow{
                    float:right;
                    transform:translateY(2px);
                }
            }
        }
    }
</style>